import { Component, inject, signal } from '@angular/core';
import { ToastService } from '@app/root/providers/toast-service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '@services/user.service';
import { createFormGroup } from '@shared/components/forms/form';
import { AccountInfoForm, AccountInfoFormModel } from '@shared/components/verify-account-info/verify-account-info-form';
import { pick } from 'lodash';

@Component({
  selector: 'app-verify-account-info',
  templateUrl: './verify-account-info.component.html',
  styleUrls: ['./verify-account-info.component.scss'],
  standalone: false,
})
export class VerifyAccountInfoComponent {
  protected modal = inject(NgbActiveModal);
  private userService = inject(UserService);
  private toastService = inject(ToastService);

  currentUser = this.userService.currentUser;
  model = signal(pick(this.currentUser(), ['username', 'firstName', 'lastName']) as AccountInfoFormModel);
  form = createFormGroup<AccountInfoFormModel>();
  fields = AccountInfoForm();
  isSaving = signal(false);

  confirm(): void {
    this.form.markAllAsTouched();
    if (!this.form.valid) return;
    this.saveUser();
  }

  private saveUser(): void {
    this.isSaving.set(true);
    this.userService.updateCurrentUser(this.model()).subscribe(result => {
      this.isSaving.set(false);
      if (!result) {
        this.toastService.showError('Failed to update account information');
      } else {
        this.toastService.show('Account information updated successfully');
        this.modal.close(result);
      }
    });
  }
}
